import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { MyElContrattiUsati } from '../../../models/interfaces/revisione.interface';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isEqual } from 'lodash-es';
import { getBaseSocialeControl } from './helpers/base-sociale-form.helper';

export const baseSocialeOccupazioneRules: FormGroupRules = {
    my_UnitaSociUtil: (form: FormGroup) => {
        const my_UnitaSociUtilControl = getBaseSocialeControl(form, 'my_UnitaSociUtil');
        const my_UnitaSociUtil = toNum(my_UnitaSociUtilControl?.value);
        const my_UnitaNonSociUtil = toNum(getBaseSocialeControl(form, 'my_UnitaNonSociUtil')?.value);
        const my_NumLavSub = toNum(getBaseSocialeControl(form, 'my_NumLavSub')?.value);
        const my_NumLavSubTempoDeterminato = toNum(getBaseSocialeControl(form, 'my_NumLavSubTempoDeterminato')?.value);
        const my_StatoVerbale: string = getControl(form, 'my_StatoVerbale')?.value;
        const my_StatoAccertamento: string = getControl(form, 'my_StatoAccertamento')?.value;
        const my_CkProposte: string = getControl(form, 'my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte')?.value;
        const my_ElContrattiUsati: MyElContrattiUsati[] = getBaseSocialeControl(form, 'my_ContrattiUsati.my_ElContrattiUsati')?.value;
        const my_NumLavParaSub = toNum(getBaseSocialeControl(form, 'my_NumLavParaSub')?.value);
        const my_NumLavAut = toNum(getBaseSocialeControl(form, 'my_NumLavAut')?.value);
        const my_NumLavAltro = toNum(getBaseSocialeControl(form, 'my_NumLavAltro')?.value);
        const my_ElContrattiUsatiFilled = my_ElContrattiUsati.length > 0 && my_ElContrattiUsati.every((x) => !!x.my_ContrUsatiDesc);
        const sommaUtilUnita = my_UnitaNonSociUtil + my_UnitaSociUtil;
        const sommaUtilRapporti = my_NumLavSub + my_NumLavSubTempoDeterminato + my_NumLavParaSub + my_NumLavAut + my_NumLavAltro;
        const errors = my_UnitaSociUtilControl.errors ? my_UnitaSociUtilControl.errors : {};
        const showSpecifyError =
            !(my_StatoVerbale === '1' && my_StatoAccertamento === '1' && my_CkProposte === '3') &&
            my_UnitaNonSociUtil + my_UnitaSociUtil > 0 &&
            !my_ElContrattiUsatiFilled &&
            my_NumLavSubTempoDeterminato + my_NumLavSub > 0;
        const showTotError = !isNilOrEmpty(sommaUtilUnita) && !isNilOrEmpty(sommaUtilRapporti) && sommaUtilUnita !== sommaUtilRapporti;

        addRemoveError(showSpecifyError, errors, 'my_UnitaSociUtil', {
            status: 'Specificare almeno un contratto.',
            message: 'In presenza di occupati (soci e/o non soci) occorre specificare almeno un contratto.',
        });

        addRemoveError(showTotError, errors, 'my_UnitaSociUtil', {
            status: 'Totali non congruenti',
        });

        addRemoveError(isNilOrEmpty(my_UnitaSociUtil), errors, 'my_UnitaSociUtil', {
            status: REQUIRED_STATUS,
        });

        my_UnitaSociUtilControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_NumLavSub: (form: FormGroup) => {
        const my_NumLavSubControl = getBaseSocialeControl(form, 'my_NumLavSub');
        const my_NumLavSub = toNum(my_NumLavSubControl?.value);
        const my_NumLavSubTempoDeterminato = toNum(getBaseSocialeControl(form, 'my_NumLavSubTempoDeterminato')?.value);
        const my_ElContrattiUsati: MyElContrattiUsati[] = getBaseSocialeControl(form, 'my_ContrattiUsati.my_ElContrattiUsati')?.value;
        const my_ElContrattiUsatiFilled = my_ElContrattiUsati.length > 0 && my_ElContrattiUsati.every((x) => !!x.my_ContrUsatiDesc);
        const errors = my_NumLavSubControl.errors ? my_NumLavSubControl.errors : {};

        addRemoveError(my_NumLavSubTempoDeterminato + my_NumLavSub === 0 && my_ElContrattiUsatiFilled, errors, 'my_NumLavSub', {
            status: 'Controllare i contratti',
            message: 'In assenza di unità subordinate non ha senso la definizione del contratto',
        });

        addRemoveError(isNilOrEmpty(my_NumLavSub), errors, 'my_NumLavSub', {
            status: REQUIRED_STATUS,
        });

        my_NumLavSubControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ContrattoLavAltro: (form: FormGroup) => {
        const my_ContrattoLavAltroControl = getBaseSocialeControl(form, 'my_ContrattoLavAltro');
        const my_NumLavAltro = toNum(getBaseSocialeControl(form, 'my_NumLavAltro')?.value);
        const errors = my_ContrattoLavAltroControl.errors ? my_ContrattoLavAltroControl.errors : {};

        addRemoveError(my_NumLavAltro > 0 && isNilOrEmpty(my_ContrattoLavAltroControl?.value), errors, 'my_ContrattoLavAltro', {
            status: REQUIRED_STATUS,
        });

        my_ContrattoLavAltroControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CtrlLavoratoriSoci: (form: FormGroup) => {
        const my_CtrlLavoratoriSociControl = getBaseSocialeControl(form, 'my_CtrlLavoratoriSoci');
        const my_TotLavoratoriSoci = toNum(getControl(form, 'my_TotLavoratoriSoci')?.value);
        const my_UnitaSociUtil = toNum(getBaseSocialeControl(form, 'my_UnitaSociUtil')?.value);
        const errors = my_CtrlLavoratoriSociControl.errors ? my_CtrlLavoratoriSociControl.errors : {};

        addRemoveError(my_TotLavoratoriSoci !== my_UnitaSociUtil, errors, 'my_CtrlLavoratoriSoci', {
            status: 'Totali non corrispondenti',
            message: "La somma dei 2 totali non è congruente con le unità occupate nell'impresa",
        });

        my_CtrlLavoratoriSociControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CtrlLavoratoriNonSoci: (form: FormGroup) => {
        const my_CtrlLavoratoriNonSociControl = getBaseSocialeControl(form, 'my_CtrlLavoratoriNonSoci');
        const my_TotLavoratoriNonSoci = toNum(getControl(form, 'my_TotLavoratoriNonSoci')?.value);
        const my_UnitaNonSociUtil = toNum(getBaseSocialeControl(form, 'my_UnitaNonSociUtil')?.value);
        const errors = my_CtrlLavoratoriNonSociControl.errors ? my_CtrlLavoratoriNonSociControl.errors : {};

        addRemoveError(my_TotLavoratoriNonSoci !== my_UnitaNonSociUtil, errors, 'my_CtrlLavoratoriNonSoci', {
            status: 'Totali non corrispondenti',
            message: "La somma dei 2 totali non è congruente con le unità occupate nell'impresa",
        });

        my_CtrlLavoratoriNonSociControl.setErrors(isEqual(errors, {}) ? null : errors);
    },
};
